import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TreeNodeComponent } from './components/tree-node/tree-node.component';
import { TreeComponent } from './components/tree/tree.component';


@NgModule({
    declarations: [
        TreeComponent,
        TreeNodeComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        MatIconModule
    ],
    exports: [
        TreeComponent,
        TreeNodeComponent
    ]
})
export class TreeModule {
}
